import {gsap} from "gsap";
import {
    inViewPointerMobile, onlyLineMask,
} from "Libs/helper";
import AnimationHelper from "Libs/animation-helper";

export class AnimationSimpleLine {
    constructor(el, options) {
        this.DOM = {el};
        if (!inViewPointerMobile(this.DOM.el)) return;
        this.DOM.el.classList.add('animation--lines');
        this.options = {...options};
        this.addAnimationType();
    }

    addAnimationType() {
        onlyLineMask(this);
        let optionsSwitch;
        optionsSwitch = {
            _from: {y: '115%',},
            _to: {
                y: '0%',
                ease: 'power3.out',
                duration: .8,
                delay: 0
            }
        };

        this.options._from = Object.assign({}, optionsSwitch._from, this.options._from);
        this.options._to = Object.assign({}, optionsSwitch._to, this.options._to);
        this.options._out = Object.assign({}, optionsSwitch._out, this.options._out);

        this.DOM.el.classList.remove('is-animation');
        gsap.set(this.DOM.elemntMask, this.options._from);

        if (this.options.handleScrolling) {
            this.animationHelper = new AnimationHelper({
                el: this.DOM.el,
                animationIn: this.animationIn.bind(this),
                options: this.options
            });
        }
    }

    animationReset() {
        gsap.set(this.DOM.elemntMask, this.options._from);
    }

    animationIn(delay = 0) {

        if (this.animationHelper) {
            delay += this.animationHelper.getDelayAnimation();
            this.animationHelper.removeHandleScrolling();
        }

        const optionTo = Object.assign({delay: 0}, this.options._to);
        optionTo.delay += delay;
        gsap.killTweensOf(this.DOM.elemntMask);
        gsap.fromTo(this.DOM.elemntMask, this.options._from, optionTo);
    }

    animationInBack(delay = 0) {

        const optionTo = Object.assign({delay: 0}, this.options._to);
        optionTo.delay += delay;
        gsap.killTweensOf(this.DOM.elemntMask);
        gsap.to(this.DOM.elemntMask, optionTo);
    }

    animationOut(delay = 0) {
        gsap.killTweensOf(this.DOM.elemntMask);
        gsap.to(this.DOM.elemntMask, {y: '-115%', ease: 'power3.out', duration: .6, delay});
    }

    animationOutBack(delay = 0) {
        gsap.killTweensOf(this.DOM.elemntMask);
        gsap.to(this.DOM.elemntMask, {y: '115%', ease: 'power3.out', duration: .6, delay});
    }

    animationInOpacity(delay){
        if (this.animationHelper) {
            delay += this.animationHelper.getDelayAnimation();
            this.animationHelper.removeHandleScrolling();
        }

        const optionTo = Object.assign({delay: 0}, this.options._to);
        optionTo.delay += delay;
        gsap.killTweensOf(this.DOM.elemntMask);
        gsap.fromTo(this.DOM.elemntMask, {...{opacity: 1}, ...this.options._from}, optionTo);
    }

    animationOUtOpacity(delay = 0) {
        gsap.killTweensOf(this.DOM.elemntMask);
        gsap.to(this.DOM.elemntMask, {opacity: '0', ease: 'power3.out', duration: .6, delay});
    }
}